












































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line no-unused-vars
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import MarkdownIt from 'markdown-it';

import BFormTextareaLimited from '@/components/input_limited/BFormTextareaLimited.vue';
import BestFitText from '@/components/BestFitText.vue';
import { IsEmbedded } from '@/constants/environment';
// eslint-disable-next-line no-unused-vars
import Node from '@/models/Node';
import Connection, { ConnectionDirection } from '@/models/Connection';
import { PacketType } from '@/models/Packet';
import StringPacking from '@/models/StringPacking';
import { SendPacket } from '@/networking/SendPacket';
import Mutations from '@/store/mutations';
// eslint-disable-next-line no-unused-vars
import StringUtil from '@/util/StringUtil';

@Component({
    computed: 
    {
        ...mapGetters([
            'checkTimelineWrite',
        ]),

        embedded()
        {
            return IsEmbedded || this.$route.fullPath.includes('app/e/');
        }
    },
    components:
    {
        BFormTextareaLimited,
        BestFitText
    }
})
export default class ConnectionEditor extends Vue 
{
    editing = false;
    md = new MarkdownIt();

    // so the template can access the enum
    ConnectionDirection = ConnectionDirection;
    
    // Properties
    @Prop(Connection) readonly connection! : Connection;
    @Prop(Boolean) readonly inConnectionManager! : Boolean;

    mounted()
    {
        setTimeout(() => 
        {
            this.$nextTick(() =>
            {
                (this.$refs.connectionName as any).focus();
            });
        }, 50);
    }

    get node1() : Node
    {
        return this.$store.state.project.nodes.get(this.connection.nodeid1);
    }
    
    get node2() : Node
    {
        return this.$store.state.project.nodes.get(this.connection.nodeid2);
    }

    get earlyNode() : Node
    {
        if (this.node1.dateStart < this.node2.dateStart)
        {
            return this.node1;
        }
        return this.node2;
    }
    
    get lateNode() : Node
    {
        if (this.node1.dateStart < this.node2.dateStart)
        {
            return this.node2;
        }
        return this.node1;
    }

    get connectionAriaLabel() : string
    {
        if (this.connection.direction == ConnectionDirection.Forward)
        {
            return `connection from ${this.earlyNode.name} to ${this.lateNode.name}`;
        }
        else if (this.connection.direction == ConnectionDirection.Backward)
        {
            return `connection from ${this.lateNode.name} to ${this.earlyNode.name}`;
        }
        else
        {
            return `connection between ${this.earlyNode.name} and ${this.lateNode.name}`;
        }
    }

    // Computed
    get selectedObject() : Connection 
    {
        return this.connection as Connection;
    }

    get editDirection() : ConnectionDirection
    {
        return this.selectedObject.direction;
    }

    set editDirection(value : ConnectionDirection)
    {
        this.selectedObject.direction = value;
        SendPacket(PacketType.UpdateConnectionDirection,
            {
                nodeone: this.connection.nodeid1, 
                nodetwo: this.connection.nodeid2, 
                value: this.connection.direction,
            });
        Vue.set(this.connection, 'direction', this.connection.direction);
    }
    
    get editDescription() : string
    {
        return this.selectedObject.description;
    }

    set editDescription(value : string)
    {
        this.selectedObject.description = value;
        SendPacket(PacketType.UpdateConnectionText,
            {
                nodeone: this.connection.nodeid1, 
                nodetwo: this.connection.nodeid2, 
                value: StringPacking.Compress(this.connection.description, this.connection.references)
            });
    }

    get editReferences() : string
    {
        return this.selectedObject.references;
    }

    set editReferences(value : string)
    {
        this.selectedObject.references = value;
        SendPacket(PacketType.UpdateConnectionText, 
            {
                nodeone: this.connection.nodeid1, 
                nodetwo: this.connection.nodeid2, 
                value: StringPacking.Compress(this.connection.description, this.connection.references)
            });
    }

    get hideDescRefBox() : boolean
    {
        return false;
        // return StringUtil.isNullOrWhiteSpace(this.connection.description)
        //     && StringUtil.isNullOrWhiteSpace(this.connection.references);
    }

    // Methods
    close()
    {
        this.$emit('close');
    }

    edit() 
    {
        if (this.editing)
        {
            this.editing = false;
            return;
        }
        this.editing = true;
    }

    deleteConnection()
    {
        SendPacket(PacketType.NodeRemoveConnection, 
            {
                nodeid: this.connection.nodeid1,
                otherid: this.connection.nodeid2
            });
        this.$store.commit(Mutations.removeConnection, this.connection);
        this.close();
    }

    renderMarkdown(text: string)
    {
        return this.md.render(text
            // pre-process
            .replace(/\<(?!\w*\:\/\/)([^\s]+\.[^\s]+)\>/g, '<https://$1>') // all links are absolute
        )
            // post-process
            .replace(/<a[ >]/g, '<a target="_blank" ') // all links target new tab/window
            .replace(/href="((?!\w+\:\/\/)[^"]+)"/g, 'href="https://$1"') // all links are absolute
            .replace(/<img[ >]/g, '<img style="max-width: 80%; max-height: 200vh; object-fit: contains;" '); // resize images
    }
}

/*
export default Vue.extend({
    props: {
        connection : {
            type: Connection,
            required: true
        }
    },
    data(){
        return {
            editing: false
        }
    },
    computed: {
        selectedObject() : Connection {
            return this.connection as Connection;
        },
        editDescription: {
            get() : string{
                return this.selectedObject.description;
            },
            set(value : string){
                this.selectedObject.description = value;
                SendPacket(PacketType.UpdateConnectionText,
                    {
                        nodeone: this.connection.nodeid1, 
                        nodetwo: this.connection.nodeid2, 
                        value: StringPacking.Compress(this.connection.description, this.connection.references)
                    }
                );
            },
        },
        editReferences: {
            get() : string{
                return this.selectedObject.references;
            },
            set(value : string){
                this.selectedObject.references = value;
                SendPacket(PacketType.UpdateConnectionText, 
                    {
                        nodeone: this.connection.nodeid1, 
                        nodetwo: this.connection.nodeid2, 
                        value: StringPacking.Compress(this.connection.description, this.connection.references)
                    }
                );
            },
        }
    },
    methods: {
        close(){
            this.$store.commit(Mutations.setSelected, null);
        },
        edit() {
            this.editing = true;
        }
    }
})*/
